export default "__VITE_ASSET__Capt4dUH__"